<template>
    <div class="loan">
        <div class="info">
            <div class="tip">*{{$t('loan.tip1')}}</div>
            <div>【{{$t('loan.tip2')}}：0.9,0.9,0.9,0.9,0.9,0.9,0.9,0.9,0.9,0.9,0.9,0.9,0.9,0.9,0.9,0.9,0.9,0.9,0.9,0.9,0.9,0.9,0.9,0.9,0.9,0.9,0.9,0.9,0.9,0.9,0.9,0.9,0.9,0.9,0.9,0.9】</div>
            <div>【{{$t('loan.tip3')}}：0.7,0.7,0.7,0.7,0.7,0.7,0.7,0.7,0.7,0.7,0.7,0.7,0.7,0.7,0.7,0.7,0.7,0.7,0.7,0.7,0.7,0.7,0.7,0.7,0.7,0.7,0.7,0.7,0.7,0.7,0.7,0.7,0.7,0.7,0.7,0.7】</div>
        </div>
        <Form :model="formItem" :label-width="100">
            <FormItem :label="$t('loan.minMoney')">
                <Input v-model="formItem.min_money"></Input>
            </FormItem>
            <FormItem :label="$t('loan.maxMoney')">
                <Input v-model="formItem.max_money"></Input>
            </FormItem>
            <FormItem :label="$t('loan.defaultMoney')">
                <Input v-model="formItem.init_money"></Input>
            </FormItem>
            <FormItem :label="$t('loan.allowMonth')">
                <Input v-model="formItem.allow_month"></Input>
            </FormItem>
            <FormItem :label="$t('loan.defaultMonth')">
                <Input v-model="formItem.init_month"></Input>
            </FormItem>
            <FormItem :label="$t('loan.serviceRate')">
                <Input
                    v-model="formItem.service_rate"
                    type="textarea"
                    :autosize="{minRows: 2,maxRows: 5}"
                ></Input>
            </FormItem>
            <FormItem :label="$t('loan.repaymentDay')">
                <Input v-model="formItem.back_date"></Input>
            </FormItem>
            <FormItem>
                <Button type="primary" @click="doPost">{{$t('submit')}}</Button>
                <Button style="margin-left: 8px">{{$t('cancel')}}</Button>
            </FormItem>
        </Form>
    </div>
</template>


<script>

export default {
    data() {
        return {
            formItem: {}
        };
    },
    mounted(){
        this.loadData();
    },
    methods: {
        doPost() {
            this.$post(this.$path.system, this.formItem).then(res => {
                if (res.success) {
                    this.$Message.success('修改成功');
                } else {
                    this.$Message.error('修改失败');
                    console.error(res);
                }
            });
        },
        loadData() {
            this.$get(this.$path.system, {
                
            }).then(res => {
                if (res.data) {
                    this.formItem = res.data;
                } else {
                    this.$Message.error('获取数据失败');
                }
            });
        }
    }
    
};
</script>

<style lang="scss" scoped>
.loan {
    .info {
        margin-bottom: 30px;
        .tip{
            color: red;
        }
        div {
            margin-top: 10px;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/system/loan.vue